const Report = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash-car" */ '@/pages/financial/tariff/trash/car/index.vue'
  )

const Create = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash-car" */ '@/pages/financial/tariff/trash/car/create.vue'
  )

const Edit = () =>
  import(
    /* webpackChunkName: "financial-tariff-trash-car" */ '@/pages/financial/tariff/trash/car/edit.vue'
  )

export default {
  name: 'FinancialTrashCarTariff',
  path: 'car',
  meta: {
    label: 'car',
    auth: 'car'
  },
  component: {
    name: 'Car',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialTariffTrashCarReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'FinancialCreateTariffTrashCar',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'FinancialEditTariffTrashCar',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
